import { ReactNode } from 'react'
import { PageWrapper } from '@touche-lts/panel-ui/dist'
import { RouteProps, Route, Redirect, RouteComponentProps } from 'react-router'
import { User } from 'services'
import { UserRoleName } from 'models'

export interface PrivateRouteProps extends RouteProps {
  allowedRoles?: UserRoleName[]
}

const PrivateRouteComponent = (props: PrivateRouteProps) => {
  const { component: Component, allowedRoles, ...rest } = props


  const render = (componentProps: RouteComponentProps): ReactNode => {
    const paths = ["/account/details", "/checkout"]

    if (!User.isAuthenticated) {
      return (
        <Redirect
          to={{
            pathname: '/stores',
            state: { from: componentProps.location }
          }}
        />
      )
    }

    if (allowedRoles && allowedRoles.length > 0) {
      const currentRole = User.roleName
      if (!currentRole || !allowedRoles.includes(currentRole)) {
        const fallback = User.isStoreAdmin ? '/my-store' : '/stores'
        return <Redirect to={{ pathname: fallback }} />
      }
    }

    return (
      <PageWrapper style={{ paddingLeft: 0, maxHeight: 'none', ...(paths.includes(componentProps?.location?.pathname) && { height: "98vh"}) }}>
        <Component {...componentProps} />
      </PageWrapper>
    )
  }

  return <Route {...rest} render={render} />;
};

const PrivateRoute = PrivateRouteComponent;
export { PrivateRoute };
